import * as angular from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../commons/types/vehicle.type";
import {$accountFactory} from "../../account/$account.factory";
import {ILogService, IRootScopeService} from "angular";
import {CoordinationsAlerts} from "./coordinations-alerts.service";
import {CoordinationRequests} from "./coordinations-requests.service";

export class CoordinationsDialogService {

  private loading: boolean;
  private cancel: any;
  private packageTypes: any;
  private timeSlots: any;
  private payload: any;
  private readonly vehicleTypes:VehicleType[]

  /* @ngInject */
  constructor(private $mdDialog, private $coordinations, private coordinationsAlerts: CoordinationsAlerts,
              private accountConstants, private coordinationRequests: CoordinationRequests,
              private systemEventsConfig, private $rootScope: IRootScopeService, private $account: $accountFactory,
              private commonsConstants, private $log: ILogService, private $filter,
              private CoordinationConstants, private moment) {
    this.vehicleTypes = Object.values(VehicleType);
  }

  createNewCoordination(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/create-new-coordination-dialog.tmpl.html').default,
      controller: function ($scope, $log, coordinationRequests) {

        $scope.loading = false;
        $scope.cancel = self.$mdDialog.cancel;
        $scope.vehicleTypes = self.vehicleTypes;
        $scope.packageTypes = self.commonsConstants.packageTypes;
        $scope.timeSlots = self.CoordinationConstants.timeSlots;
        $scope.file = undefined;

        $scope.payload = {
          slaNotBefore: self.moment().startOf('day').toDate(),
          slaNotAfter: self.moment().add(3, 'day').endOf('day').toDate(),
          timeSlots: [],
          ownerDetails: {},
          packageList: {
            items: []
          }
        };

        $scope.minDate = angular.copy($scope.payload.slaNotBefore);

        // ******************************
        // External methods
        // ******************************

        $scope.onSelectAccount = (accountId) => {
          self._selectAccount(self, accountId, self.payload);
        }

        $scope.onAddressChange = (address) => {
          self._addressChange(address, self.payload, 'ownerDetails')
        }

        $scope.onMinDateChange = (selectedDate) => {
          if (selectedDate > $scope.payload.slaNotAfter) {
            $scope.payload.slaNotAfter = selectedDate;
          }
        }

        $scope.onMaxDateChange = (selectedDate) => {
          $scope.payload.slaNotAfter = selectedDate;
        }


        $scope.onAddFile = (file) => {
          $scope.file = file;
          if (file) {
            $scope.loading = true;
            self.coordinationRequests.uploadCoordinationExcel(file)
              .then((res) => {
                $scope.payload.serviceTemplateList = res.data;
              })
              .catch((error) => {
                $log.error('Failed to upload excel to server, ' +
                  'createNewCoordination@onAddFile' + error)
              })
              .finally(() => {
                $scope.loading = false;
              })
          }
        }


        $scope.submitForm = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {
            const payload = angular.copy($scope.payload);

            if (_.has($scope.payload, 'ownerDetails.phoneNumber')) {
              payload.ownerDetails.phoneNumber = self.$filter('bringozPhonePrefix')($scope.payload.ownerDetails.phoneNumber)
            }

            _.set(payload, 'packageList', []);
            payload.packageList.push($scope.payload.packageList);
            payload.slaNotBefore =  self.moment(payload.slaNotBefore).startOf('day').valueOf();
            payload.slaNotAfter =  self.moment(payload.slaNotAfter).endOf('day').valueOf();

            $scope.doUpdate(payload);
          }

        }

        // ******************************
        //        Internal methods
        // ******************************

        $scope.doUpdate = (payload) => {
          self._changeLoadingState($scope, true);
          self.$coordinations().$put(payload)
            .then((createdCoordination) => {
              self._changeLoadingState($scope, false);
              self.$mdDialog.hide(createdCoordination);
            })
            .catch((error) => {
              self._changeLoadingState($scope, false);
              self.$log.error('Failed to create new coordination , ' +
                'coordinationsDialogService@createNewCoordination@doUpdate \n' + error);
              self.$mdDialog.hide();
            });
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editCoordination(event, coordination) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/edit-coordination-dialog.tmpl.html').default,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.payload = angular.copy(coordination);
        if (!$scope.payload.packageList) {
          $scope.payload.packageList = {
            items: []
          }
        } else {
          $scope.payload.packageList = $scope.payload.packageList[0];
        }


        $scope.vehicleTypes = self.vehicleTypes;
        $scope.packageTypes = self.commonsConstants.packageTypes;

        $scope.payload.slaNotBefore = new Date($scope.payload.slaNotBefore);
        $scope.payload.slaNotAfter = new Date($scope.payload.slaNotAfter);
        $scope.timeSlots = self.CoordinationConstants.timeSlots;

        if (_.has($scope.payload, 'ownerDetails.phoneNumber')) {
          $scope.payload.ownerDetails.phoneNumber = self.$filter('bringozPhone')($scope.payload.ownerDetails.phoneNumber);
        }

        // ******************************
        // External methods
        // ******************************

        $scope.onSelectAccount = (accountId) => {
          self._selectAccount($scope, accountId, $scope.payload);
        }

        $scope.onAddressChange = (address) => {
          self._addressChange(address, $scope.payload, 'ownerDetails');
        }

        $scope.onMinDateChange = (selectedDate) => {
          if (selectedDate > $scope.payload.slaNotAfter) {
            $scope.payload.slaNotAfter = selectedDate;
          }
        }

        $scope.onMaxDateChange = (selectedDate) => {
          $scope.payload.slaNotBefore = selectedDate;
        }

        $scope.submitForm = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {

            const coordinationForUpdate = angular.copy($scope.payload);

            if (_.has($scope.payload, 'ownerDetails.phoneNumber')) {
              coordinationForUpdate.ownerDetails.phoneNumber = self.$filter('bringozPhonePrefix')($scope.payload.ownerDetails.phoneNumber)
            }

            _.set(coordinationForUpdate, 'packageList', []);
            coordinationForUpdate.packageList.push($scope.payload.packageList);

            coordinationForUpdate.slaNotBefore =  self.moment(coordinationForUpdate.slaNotBefore).startOf('day').valueOf();
            coordinationForUpdate.slaNotAfter = self.moment(coordinationForUpdate.slaNotAfter).endOf('day').valueOf();

            if (coordinationForUpdate.ownerDetails.phoneNumber) {
              coordinationForUpdate.ownerDetails.phoneNumber =  self.$filter('bringozPhonePrefix')(coordinationForUpdate.ownerDetails.phoneNumber);
            }

            if (!_.isEqual(coordinationForUpdate, coordination)) {
              $scope.doUpdate(coordinationForUpdate);
            }
            else {
              self.$mdDialog.cancel();
            }
          }

        }

        // ******************************
        //        Internal methods
        // ******************************

        $scope.doUpdate = (coordinationForUpdate) => {
          self._changeLoadingState($scope, true);
          self.$coordinations(coordinationForUpdate.id).$post(coordinationForUpdate)
            .then((updatedCoordination) => {
              self._changeLoadingState($scope, false);
              self.$mdDialog.hide(updatedCoordination);
            })
            .catch((error) => {
              self._changeLoadingState($scope, false);
              self.$log.error('Failed to create new coordination , ' +
                'coordinationsDialogService@createNewCoordination@doUpdate \n' + error);
              self.$mdDialog.hide();
            });
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  createAllDeliveries(event, coordination) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/create-all-deliveries-dialog.tmpl.html').default,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.hasOwnerId = !_.isUndefined(coordination.ownerId);

        $scope.coordinationCopy = angular.copy(coordination);
        $scope.coordinationCopy.packageList = $scope.coordinationCopy.packageList[0];

        $scope.serviceTemplateDeliveryData = {
          accountId: $scope.coordinationCopy.ownerId,
          packageList: $scope.coordinationCopy.packageList,
          vehicleType: $scope.coordinationCopy.vehicleType || null,
          identifications: {
            signature: false,
            showIdCard: false,
            photographIdCard: false,
            photographPerson: false
          }

        };

        if (_.isUndefined($scope.coordinationCopy.ownerDetails)) {
          _.set($scope.coordinationCopy, 'ownerDetails', {})
        }

        if (_.has($scope.coordinationCopy.ownerDetails, 'phoneNumber')) {
          $scope.coordinationCopy.ownerDetails.phoneNumber = self.$filter('bringozPhone')($scope.coordinationCopy.ownerDetails.phoneNumber);
        }

        $scope.vehicleTypes = self.vehicleTypes;
        $scope.packageTypes = self.commonsConstants.packageTypes;

        const identifications = {
          signature: false,
          showIdCard: false,
          photographIdCard: false,
          photographPerson: false
        };
        _.set($scope.coordinationCopy, 'identifications', identifications);

        // ******************************
        // External methods
        // ******************************

        $scope.onSelectAccount = (accountId) => {
          self._selectAccount($scope, accountId, $scope.coordinationCopy);
        }

        $scope.onAddressChange = (address) => {
          self._addressChange(address, $scope.coordinationCopy, 'ownerDetails')
        }


        $scope.submitForm = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {

            // var payload = angular.copy($scope.coordinationCopy);
            const payload = $scope.serviceTemplateDeliveryData;
            _.set(payload, 'packageList', []);
            payload.packageList.push($scope.coordinationCopy.packageList);


            if (_.isUndefined(payload.accountId)) {
              _.set(payload, 'accountId', $scope.coordinationCopy.ownerId);
              if (_.has($scope.coordinationCopy, 'ownerDetails.phoneNumber')) {
                $scope.coordinationCopy.ownerDetails.phoneNumber = self.$filter('bringozPhonePrefix')($scope.coordinationCopy.ownerDetails.phoneNumber);
              }

              _.set(payload, 'ownerDetails', $scope.coordinationCopy.ownerDetails);
            }

            $scope.doUpdate(payload);
          }

        }

        // ******************************
        //        Internal methods
        // ******************************

        $scope.doUpdate = (payload) => {

          self._changeLoadingState($scope, true);
          self.coordinationRequests.createAllDeliveries(coordination.id, payload)
            .then((createdDelivery) => {
              self._changeLoadingState($scope, false);
              self.$mdDialog.hide(createdDelivery);
            })
            .catch((error) => {
              self._changeLoadingState($scope, false);
              self.$log.error('Failed to create new coordination , ' +
                'coordinationsDialogService@createNewCoordination@doUpdate \n' + error);
              self.$mdDialog.hide();
            });
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  createDeliveries(event, coordination, serviceIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/create-deliveries-dialog.tmpl.html').default,
      controller: function ($scope) {

        if (!_.isArray(serviceIds)) {
          serviceIds = [serviceIds];
        }

        $scope.loading = false;
        $scope.cancel = self.$mdDialog.cancel;
        $scope.hasOwnerId = !_.isUndefined(coordination.ownerId);
        $scope.coordinationCopy = angular.copy(coordination);

        const selectedPackageList = $scope.coordinationCopy.packageList[0];
        $scope.vehicleTypes = self.vehicleTypes;
        $scope.packageTypes = self.commonsConstants.packageTypes;


        $scope.serviceTemplateDeliveryData = {
          accountId: coordination.ownerId,
          packageList: $scope.coordinationCopy.packageList ? selectedPackageList : null,
          vehicleType: $scope.coordinationCopy.vehicleType || null,
          identifications: {
            signature: false,
            showIdCard: false,
            photographIdCard: false,
            photographPerson: false
          }

        };

        if (_.isUndefined($scope.coordinationCopy.ownerDetails)) {
          _.set($scope.coordinationCopy, 'ownerDetails', {})
        }

        if (_.has($scope.coordinationCopy.ownerDetails, 'phoneNumber')) {
          $scope.coordinationCopy.ownerDetails.phoneNumber = self.$filter('bringozPhone')($scope.coordinationCopy.ownerDetails.phoneNumber);
        }

        // ******************************
        // External methods
        // ******************************

        $scope.onSelectAccount = (accountId) => {
          self._selectAccount($scope, accountId, $scope.coordinationCopy);
        }

        $scope.onAddressChange = (address) => {
          self._addressChange(address, $scope.coordinationCopy, 'ownerDetails')
        }


        $scope.submitForm = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {

            const payload = angular.copy($scope.serviceTemplateDeliveryData);
            const packageListForPayload = [];
            packageListForPayload.push($scope.serviceTemplateDeliveryData.packageList);
            payload.packageList = packageListForPayload;

            if (_.isUndefined(payload.accountId)) {
              _.set(payload, 'accountId', $scope.coordinationCopy.ownerId);
              if (_.has($scope.coordinationCopy, 'ownerDetails.phoneNumber')) {
                $scope.coordinationCopy.ownerDetails.phoneNumber = self.$filter('bringozPhonePrefix')($scope.coordinationCopy.ownerDetails.phoneNumber);
              }

              _.set(payload, 'ownerDetails', $scope.coordinationCopy.ownerDetails);
            }

            $scope.doUpdate(payload);
          }

        }

        // ******************************
        //        Internal methods
        // ******************************


        $scope.doUpdate = (payload) => {
          self._changeLoadingState($scope, true);
          self.coordinationRequests.createDeliveries(serviceIds, payload)
            .then((createdService) => {
              self.$mdDialog.hide(createdService);
            })
            .catch((error) => {
              if (error && _.isEqual(error.status, 450)) {
                if (_.isEqual(error.data.code,'OUT_OF_SERVICE_ZONE')) {
                  self.coordinationsAlerts.outOfServiceZoneError();
                }

                if (_.isEqual(error.data.code,'NO_VALID_PAYMENT_METHOD')) {
                  self.coordinationsAlerts.noValidPaymentMethodError();
                }
              }
              $scope.cancel(error);
            })
            .finally(() => {
              self._changeLoadingState($scope, false);
            })
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editService(event, service) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/edit-service-dialog.tmpl.html').default,
      controller: function ($scope) {

        var address1;
        $scope.loading = false;
        $scope.cancel = self.$mdDialog.cancel;
        $scope.payload = angular.copy(service);

        var today = self.moment().valueOf();
        $scope.defaultFromDate =  today > $scope.payload.slaNotBefore ? today : $scope.payload.slaNotBefore;
        $scope.defaultFromDate = new Date($scope.defaultFromDate);

        if (!$scope.payload.coordinationTask.coordinatedDate) {
          $scope.payload.coordinationTask.coordinatedDate = $scope.defaultFromDate;
        }

        if (_.has($scope.payload.coordinationTask, 'coordinatedDate')) {
          $scope.payload.coordinationTask.coordinatedDate = new Date($scope.payload.coordinationTask.coordinatedDate);
        }

        $scope.payload.slaNotBefore = new Date($scope.payload.slaNotBefore);
        $scope.payload.slaNotAfter = new Date($scope.payload.slaNotAfter);


        if (_.isUndefined($scope.payload.coordinationTask)) {
          _.set($scope.payload, 'coordinationTask', {})
        }

        if (_.has($scope.payload.coordinationTask, 'address')) {
          address1 = $scope.payload.coordinationTask.address.address1;
          if (_.isUndefined($scope.payload.coordinationTask.address.place)) {
            _.set($scope.payload.coordinationTask.address, 'place', $scope.payload.coordinationTask.address.address1)
          }
        }

        if (_.has($scope.payload.coordinationTask, 'phoneNumber')) {
          $scope.payload.coordinationTask.phoneNumber = self.$filter('bringozPhone')($scope.payload.coordinationTask.phoneNumber);
        }

        /////////////////////////////////////////////////

        $scope.onAddressChange = (address) => {
          self._addressChange(address, $scope.payload, 'coordinationTask');
        }

        $scope.submitForm = (form) => {

          if (!_.get($scope.payload, 'coordinationTask.address.placeId')) {
            form.address.$setValidity('required', false);
          }

          form.$setSubmitted(true);

          if (form.$valid) {

            var serviceForUpdate = angular.copy($scope.payload);

            if (serviceForUpdate.coordinationTask.address && address1) {
              _.set(serviceForUpdate.coordinationTask.address, 'address1', address1);
            }

            if (_.has($scope.payload, 'coordinationTask.phoneNumber')) {
              serviceForUpdate.coordinationTask.phoneNumber = self.$filter('bringozPhonePrefix')($scope.payload.coordinationTask.phoneNumber);
            }

            if (_.has(serviceForUpdate.coordinationTask, 'phoneNumber')) {
              serviceForUpdate.coordinationTask.phoneNumber = self.$filter('bringozPhonePrefix')(serviceForUpdate.coordinationTask.phoneNumber);
            }

            if (_.has(serviceForUpdate.coordinationTask, 'coordinatedDate')) {
              serviceForUpdate.coordinationTask.coordinatedDate = self.moment(serviceForUpdate.coordinationTask.coordinatedDate).startOf('day').valueOf();
            }

            $scope.doUpdate(serviceForUpdate);
          }

        }

        $scope.doUpdate = (serviceForUpdate) => {
          self._changeLoadingState($scope, true);
          self.coordinationRequests.editService(service.id, serviceForUpdate)
            .then((createdCoordination) => {
              self._changeLoadingState($scope, false);
              self.$mdDialog.hide(createdCoordination);
            })
            .catch((error) => {
              self._changeLoadingState($scope, false);
              $scope.$log.error('Failed to create new coordination , ' +
                'coordinationsDialogService@editService@doUpdate \n' + error);
              self.$mdDialog.hide();
            });
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  // ******************************
  //        Internal methods
  // ******************************


  private _setAddressProperty(payload) {
    if (_.isUndefined(payload.ownerDetails)) {
      _.set(payload, 'ownerDetails.address', {})
    }
  }

  private _changeLoadingState(scope, state)  {
    scope.loading = state;
    this.$rootScope.$broadcast(this.systemEventsConfig.forms.fieldsetToggle, state);
  }

  private _addressChange(fullAddress, payload, property) {

    // if (_.isEqual(property, 'ownerDetails')) {
    //     _setAddressProperty(payload);
    // }

    if (_.isUndefined(payload[property])) {
      _.set(payload, property, {});
      _.set(payload[property], 'address', {})
    }

    var apartment,
      floor;

    if (_.has(payload[property].address, 'floor')) {
      floor = payload[property].address.floor;
    }

    if (_.has(payload[property].address, 'apartment')) {
      apartment = payload[property].address.apartment;
    }

    payload[property].address = fullAddress;
    _.set(payload[property].address, 'apartment', apartment);
    _.set(payload[property].address, 'floor', floor);

  }

  private _selectAccount(scope, accountId, payload) {

    if (_.isUndefined(accountId)) {
      _.unset(payload, 'ownerId');
      _.unset(payload, 'ownerDetails.address');
      _.unset(payload, 'ownerDetails.name');
      _.unset(payload, 'ownerDetails.phoneNumber');
      scope.$broadcast(this.accountConstants.events.addressChanged, undefined);

    } else {
      payload.ownerId = accountId;

      this.$account(accountId).$asyncValue()
        .then((account) => {
          this._setAddressProperty(payload);
          _.set(payload, 'ownerDetails.address', account.address);
          _.set(payload, 'ownerDetails.name', account.name);
          _.set(payload, 'ownerDetails.phoneNumber', this.$filter('bringozPhone')(account.phoneNumber));
          scope.$broadcast(this.accountConstants.events.addressChanged, account.address);
        })
        .catch((error) => {
          this.$log.error('Failed to get account, ' +
            'coordinationsDialogService@selectAccount \n' + error)
        });
    }
  }

}

angular
  .module('bringoz.admin.coordinations')
  .service('coordinationsDialogService', CoordinationsDialogService);
